import { CHECKOUT_ACTION_TYPES } from '../actions/checkoutActions';

const initialState = {
  // Checkout step: 'address', 'payment', 'review'
  step: 'address',

  // Shipping address
  shippingAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    pincode: '',
    phone: ''
  },

  // Billing address (if different from shipping)
  billingAddress: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    pincode: '',
    phone: ''
  },

  // Whether billing is same as shipping
  sameAsBilling: true,

  // Guest user information
  guestInfo: {
    name: '',
    email: '',
    phone: ''
  },

  // Checkout currently offers online payment through Razorpay.
  paymentMethod: 'RAZORPAY',

  // Delivery information. Checkout does not validate or restrict pincodes.
  deliveryInfo: {
    pincode: '',
    deliveryCharge: '0.00',
    estimatedDays: 0,
    estimatedDate: '',
    city: '',
    state: ''
  },

  // Order notes
  notes: '',

  // Current order after creation
  currentOrder: null,

  // Loading states
  loading: {
    order: false
  },

  // Error state
  error: null
};

const checkoutReducer = (state = initialState, action) => {
  switch (action.type) {
    // Step management
    case CHECKOUT_ACTION_TYPES.SET_CHECKOUT_STEP:
      return {
        ...state,
        step: action.payload,
        error: null
      };

    case CHECKOUT_ACTION_TYPES.RESET_CHECKOUT:
      return {
        ...initialState
      };

    // Shipping address
    case CHECKOUT_ACTION_TYPES.SET_SHIPPING_ADDRESS:
      return {
        ...state,
        shippingAddress: {
          ...state.shippingAddress,
          ...action.payload
        },
        error: null
      };

    // Billing address
    case CHECKOUT_ACTION_TYPES.SET_BILLING_ADDRESS:
      return {
        ...state,
        billingAddress: {
          ...state.billingAddress,
          ...action.payload
        },
        error: null
      };

    // Same as billing toggle
    case CHECKOUT_ACTION_TYPES.SET_SAME_AS_BILLING:
      return {
        ...state,
        sameAsBilling: action.payload,
        error: null
      };

    // Guest info
    case CHECKOUT_ACTION_TYPES.SET_GUEST_INFO:
      return {
        ...state,
        guestInfo: {
          ...state.guestInfo,
          ...action.payload
        },
        error: null
      };

    // Payment method
    case CHECKOUT_ACTION_TYPES.SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.payload,
        error: null
      };

    // Order creation
    case CHECKOUT_ACTION_TYPES.CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          order: true
        },
        error: null
      };

    case CHECKOUT_ACTION_TYPES.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: {
          ...state.loading,
          order: false
        },
        currentOrder: action.payload,
        step: 'confirmation',
        error: null
      };

    case CHECKOUT_ACTION_TYPES.CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          order: false
        },
        error: action.payload
      };

    // Notes
    case CHECKOUT_ACTION_TYPES.SET_ORDER_NOTES:
      return {
        ...state,
        notes: action.payload
      };

    // Error handling
    case CHECKOUT_ACTION_TYPES.SET_CHECKOUT_ERROR:
      return {
        ...state,
        error: action.payload
      };

    case CHECKOUT_ACTION_TYPES.CLEAR_CHECKOUT_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default checkoutReducer;
